import { useState } from 'react';

// 5 tailored questions and 3-5 line answers for each treatment
const TREATMENT_FAQS = {
  'fysiurgisk-massage': {
    heading: 'Ofte stillede spørgsmål om fysiurgisk massage & sportsmassage',
    items: [
      {
        q: 'Hvordan adskiller fysiurgisk massage sig fra almindelig wellnessmassage?',
        a: 'Fysiurgisk massage er en dybdegående og anatomisk funderet behandlingsform, der arbejder målrettet i muskler, sener og bindevæv. Mens almindelig wellnessmassage primært har fokus på overfladisk afspænding, tager fysiurgisk massage fat i selve årsagerne til smerter, myoser og nedsat bevægelighed. Behandlingen tilpasses altid individuelt efter dine specifikke problemområder for at genskabe kroppens naturlige balance og funktion.'
      },
      {
        q: 'Gør en dybdegående fysiurgisk massage eller sportsmassage ondt?',
        a: 'Behandlingen kan i visse områder føles som en intens, forløsende smerte, særligt når vi arbejder på stramme muskelknuder, spændinger eller arvæv. Vi tilpasser dog altid trykket løbende i tæt dialog med dig, så smerten aldrig bliver uudholdelig eller overstiger din smertetærskel. Målet er at få musklerne til at give slip og slappe af, ikke at skabe unødig kropslig modstand eller kramper.'
      },
      {
        q: 'Kan jeg få tilskud via min sundhedsforsikring, Falck eller AP Pension?',
        a: 'Ja, Tine er RAB-godkendt (Registreret Alternativ Behandler), hvilket er det eneste officielle kvalitetsstempel for massører i Danmark og det krav sundhedsforsikringer stiller for at dække massage. Fysiurgisk massage hos Tine er desuden godkendt ved Falck Healthcare, som netop har meddelt, at massage også dækkes ved AP Pensions sundhedsforsikring. Kontakt dit forsikringsselskab forud for din tid og medbring gerne dit bevillingsnummer.'
      },
      {
        q: 'Hvor ofte bør jeg få massage for at opnå det bedste resultat?',
        a: 'Ved akutte smerter, hold i nakken eller genstridige muskelknuder anbefaler vi ofte 2-3 behandlinger med 1-2 ugers mellemrum for at bryde smertemønstret. Når den akutte tilstand er aftaget, vælger mange af vores klienter en forebyggende vedligeholdelsesbehandling hver 4. til 6. uge. Dette holder kroppen smidig, forebygger tilbagevendende overbelastninger og modvirker de spændinger, som opstår i hverdagen.'
      },
      {
        q: 'Hvad skal jeg medbringe til behandlingen?',
        a: 'Du bedes venligst selv medbringe et lagen og et almindeligt håndklæde til briksen. Skal du have zoneterapi, må du meget gerne medbringe et stort badehåndklæde for optimal komfort under behandlingen.'
      }
    ]
  },
  'zoneterapi': {
    heading: 'Ofte stillede spørgsmål om RAB-godkendt zoneterapi',
    items: [
      {
        q: 'Hvordan virker zoneterapi på kroppen og vores indre organer?',
        a: 'Zoneterapi tager udgangspunkt i, at hele kroppen, dens organer, kirtler og nervebaner er afspejlet i specifikke reflekszoner under og på oversiden af fødderne. Når der opstår ubalancer, affaldsstoffer eller spændinger i et område af kroppen, vil den tilsvarende zone på foden ofte være øm ved berøring. Ved målrettede tryk og massageteknikker stimuleres blodcirkulationen, nervesystemet beroliges, og kroppens egne selvhelbredende kræfter aktiveres.'
      },
      {
        q: 'Hvilke symptomer og lidelser kan zoneterapi hjælpe imod?',
        a: 'Zoneterapi er velegnet til en lang række fysiske og psykiske problemstillinger hos både spædbørn, børn og voksne. Behandlingen anvendes med stor succes mod fordøjelsesbesvær, hovedpine, migræne, hormonelle ubalancer, menstruationssmerter samt stress og søvnbesvær. Hos spædbørn ser vi ofte fantastiske resultater ved mavekneb, kolik, refluks og generel motorisk uro.'
      },
      {
        q: 'Kan jeg få tilskud fra Sygeforsikringen ”danmark” eller min sundhedsforsikring?',
        a: 'Ja, Sophie Hebsgaard Ede er RAB-godkendt zoneterapeut, hvilket er din garanti for en høj faglig standard og godkendt uddannelse. RAB-godkendelsen betyder, at Sygeforsikringen ”danmark” yder tilskud til zoneterapi, hvis du har en lægelig diagnose eller generel dækning. Mange private sundhedsordninger og arbejdsgiverforsikringer dækker ligeledes behandlingen helt eller delvist.'
      },
      {
        q: 'Hvordan føles en zoneterapibehandling under fødderne?',
        a: 'Behandlingen opleves af de fleste som behagelig, dybt afstressende og forløsende for både krop og sind. På punkter med markante ubalancer kan trykket kortvarigt føles ømt eller prikkende, men vi afstemmer altid styrken præcist efter din krops tolerance. Mange klienter falder i en behagelig døs undervejs, og du vil efterfølgende mærke en varm, let fornemmelse i fødderne og hele kroppen.'
      },
      {
        q: 'Hvilke reaktioner kan jeg opleve i kroppen efter en behandling?',
        a: 'Det er helt normalt at opleve udrensende reaktioner i dagene efter, hvilket er et positivt tegn på, at kroppen reagerer og arbejder. Almindelige reaktioner inkluderer behagelig træthed, ændret farve eller lugt af urin, øget tarmfunktion eller kortvarig opblussen af gamle symptomer. Husk at drikke rigeligt med rent vand efter behandlingen for at støtte kroppens naturlige udskillelse af affaldsstoffer.'
      }
    ]
  },
  'ems-traening': {
    heading: 'Ofte stillede spørgsmål om EMS dragt (ingen træning)',
    items: [
      {
        q: 'Hvad er forskellen på EMS dragten hos Djurs Massage og almindelig EMS fitness?',
        a: 'Hos Djurs Massage er der tale om KUN dragt – absolut ingen hård træning! Du skal ikke lave udmattende squats, lunges eller svede. Dragten aktiverer muskulaturen gennem milde, målrettede elektriske impulser, mens du slapper af. Formålet er skånsom muskelstyrkelse, smertelindring og afspænding – ikke hård konditionstræning.'
      },
      {
        q: 'Gør det ondt at have EMS dragten på?',
        a: 'Nej, det gør ikke ondt. Impulserne føles som en intens, prikkende eller vibrerende muskelaktivering. Intensiteten indstilles altid individuelt og trappes gradvist op, så det føles behageligt og trygt for dig hele vejen igennem.'
      },
      {
        q: 'Hvordan virker EMS dragten smertelindrende?',
        a: 'EMS-impulserne stimulerer nervesystemet til at frigive kroppens egne smertehæmmende stoffer. Samtidig får den kontrollerede muskelaktivering muskler og sener til at slippe deres spændinger, så det konstante træk i leddene ophører. Det giver ofte øjeblikkelig og markant lettelse ved stivhed og smerter.'
      },
      {
        q: 'Kan EMS dragten kombineres med fysiurgisk massage?',
        a: 'Ja, det er en af vores mest populære kombinationer. EMS dragten varmer og forbereder muskelvævet i dybden, så den efterfølgende fysiurgiske massage kan arbejde endnu dybere og mere effektivt med de fastlåste spændinger.'
      },
      {
        q: 'Hvor ofte kan man benytte EMS dragten, og koster det noget at prøve?',
        a: 'Det afhænger af dit formål. Mange bruger dragten 1-2 gange om ugen som led i en smertelindrende eller muskelstyrkende indsats, eller forud for massage. Sessionen koster 300 kr. for 30 minutter (da der er afsat tid til i- og udstigning af dragt samt rengøring). Bemærk, at vi ikke tilbyder gratis prøvetræning.'
      }
    ]
  },
  'ems-dragter-traening': {
    heading: 'Ofte stillede spørgsmål om EMS dragt (ingen træning)',
    items: [
      {
        q: 'Hvad er forskellen på EMS dragten hos Djurs Massage og almindelig EMS fitness?',
        a: 'Hos Djurs Massage er der tale om KUN dragt – absolut ingen hård træning! Du skal ikke lave udmattende squats, lunges eller svede. Dragten aktiverer muskulaturen gennem milde, målrettede elektriske impulser, mens du slapper af. Formålet er skånsom muskelstyrkelse, smertelindring og afspænding – ikke hård konditionstræning.'
      },
      {
        q: 'Gør det ondt at have EMS dragten på?',
        a: 'Nej, det gør ikke ondt. Impulserne føles som en intens, prikkende eller vibrerende muskelaktivering. Intensiteten indstilles altid individuelt og trappes gradvist op, så det føles behageligt og trygt for dig hele vejen igennem.'
      },
      {
        q: 'Hvordan virker EMS dragten smertelindrende?',
        a: 'EMS-impulserne stimulerer nervesystemet til at frigive kroppens egne smertehæmmende stoffer. Samtidig får den kontrollerede muskelaktivering muskler og sener til at slippe deres spændinger, så det konstante træk i leddene ophører. Det giver ofte øjeblikkelig og markant lettelse ved stivhed og smerter.'
      },
      {
        q: 'Kan EMS dragten kombineres med fysiurgisk massage?',
        a: 'Ja, det er en af vores mest populære kombinationer. EMS dragten varmer og forbereder muskelvævet i dybden, så den efterfølgende fysiurgiske massage kan arbejde endnu dybere og mere effektivt med de fastlåste spændinger.'
      },
      {
        q: 'Hvor ofte kan man benytte EMS dragten, og koster det noget at prøve?',
        a: 'Det afhænger af dit formål. Mange bruger dragten 1-2 gange om ugen som led i en smertelindrende eller muskelstyrkende indsats, eller forud for massage. Sessionen koster 300 kr. for 30 minutter (da der er afsat tid til i- og udstigning af dragt samt rengøring). Bemærk, at vi ikke tilbyder gratis prøvetræning.'
      }
    ]
  },
  'relax-massage': {
    heading: 'Ofte stillede spørgsmål om Relax massage ved Dianna',
    items: [
      {
        q: 'Hvad er formålet med Relax massage sammenlignet med fysiurgisk massage?',
        a: 'Relax massage er en ren wellness- og afspændingsbehandling, hvor tempoet sænkes, og nervesystemet bringes i ro. Hvor fysiurgisk massage fokuserer på dybe muskelspændinger, skader og anatomisk korrektion med hårdere tryk, bruger Relax massage blide, flydende strøg og beroligende olier. Formålet er at fjerne stress, sænke kroppens kortisolniveau og give dig en pause med ultimativ forkælelse.'
      },
      {
        q: 'Hvem udfører Relax massage hos Djurs Massage?',
        a: 'Behandlingen udføres af vores dygtige kosmetolog Dianna, der er uddannet i Spanien og har specialiseret sig i krops- og hudpleje. Dianna lægger stor vægt på nærvær, diskretion og en varm, tryg atmosfære, hvor du kan koble helt fra hverdagens travlhed. Behandlingen tilpasses altid, så du føler dig godt tilpas fra det øjeblik, du træder ind i klinikken.'
      },
      {
        q: 'Kan jeg vælge mellem rygmassage og helkropsmassage?',
        a: 'Ja, du kan vælge en 30 minutters fokuseret behandling af ryg, skuldre og nakke, eller en komplet 60 minutters helkropsmassage. En 30 minutters pause er oplagt, hvis du hurtigt vil løsne hverdagens spændinger i overkroppen. Med 60 minutter får du en helhedsoplevelse, hvor både ben, arme, ryg og nakke inddrages i en rolig og afbalanceret rytme.'
      },
      {
        q: 'Kan jeg kombinere Relax massage med andre skønheds- eller wellnessbehandlinger?',
        a: 'Ja, det er meget populært at kombinere Relax massage med enten en plejende pedicure, skånsom voksbehandling eller zoneterapi. Mange vælger for eksempel en 30 minutters rygmassage i forlængelse af en fodbehandling for at opnå en helhedsorienteret forkælelse. Du kan nemt booke de ønskede ydelser i forlængelse af hinanden via vores online bookingsystem.'
      }
    ]
  },
  'voksbehandling': {
    heading: 'Ofte stillede spørgsmål om voksbehandling og hårfjerning',
    items: [
      {
        q: 'Hvilke områder tilbyder I voksbehandling og hårfjerning af?',
        a: 'Vores kosmetolog Dianna udfører professionel voksbehandling af blandt andet ben, arme, ryg og bikini. Bemærk at bryn og overlæbe udføres med præcis threading (trådning) for det mest skånsomme og veldefinerede resultat.'
      },
      {
        q: 'Hvor ofte skal jeg have voksbehandling for at holde huden glat?',
        a: 'De fleste oplever glat hud i 3-6 uger. Når behandlingen udføres med den rette voks i klinikken, opnås et holdbart og ensartet resultat, og hårene vokser med tiden blødere og finere ud.'
      },
      {
        q: 'Hvordan foregår vejledning før og efter behandlingen?',
        a: 'Du behøver ikke bekymre dig om komplicerede forholdsregler på forhånd. Vi bruger den helt rette, professionelle voks, og Dianna vejleder dig grundigt og personligt i klinikken i forbindelse med din behandling.'
      },
      {
        q: 'Hvad skal jeg medbringe til behandlingen?',
        a: 'Vi anvender ikke engangsmateriale. Derfor bedes du altid medbringe dit eget rene lagen og håndklæde til din behandling, ligesom til alle klinikkens øvrige behandlinger.'
      }
    ]
  },
  'pedicure-fodbehandling': {
    heading: 'Ofte stillede spørgsmål om pedicure & fodbehandling',
    items: [
      {
        q: 'Hvad indeholder en kosmetologisk pedicure hos Djurs Massage?',
        a: 'En pedicure hos vores uddannede kosmetolog Dianna starter med et blødgørende fodbad med urtesalte. Herefter fjernes hård hud nænsomt ved skånsom slibning og filing (hård hud beskæres ikke, da slibning/filing er langt mere skånsomt for huden). Neglene klippes og formes, neglebånd renses og næres med plejende olie, og behandlingen afsluttes med en let fodmassage og fugtighedscreme.'
      },
      {
        q: 'Hvor ofte bør man få professionel fodpleje og pedicure?',
        a: 'Vi anbefaler generelt en professionel fodbehandling hver 4. til 6. uge for at holde fødderne sunde og forebygge hård hud og hælrevner. Hvis du står meget op i løbet af din arbejdsdag, dyrker meget sport eller har tendens til tør hud, kan hyppigere besøg være en stor fordel. Regelmæssig pleje sikrer, at dine fødder forbliver velplejede, smertefri og modstandsdygtige hele året rundt.'
      },
      {
        q: 'Behandler I nedgroede negle, ligtorne og dybe hælrevner?',
        a: 'Vores kosmetologiske fodpleje afhjælper effektivt almindelig hård hud, tørhed, ru hæle og overfladiske neglegener med stor omhu og professionelle teknikker. Hvis der er tale om svære medicinske fodlidelser, dybe betændelsestilstande eller diabetesrelaterede fodsår, henviser vi altid til en autoriseret statsautofodterapeut. Er du i tvivl om dine fødders behov, er du altid velkommen til at rådføre dig med os forud for tidsbestilling.'
      },
      {
        q: 'Kan jeg kombinere pedicure med zoneterapi for ekstra velvære?',
        a: 'Ja, det er en fantastisk og meget populær kombination at forene kosmetologisk fodpleje med en dybdegående zoneterapibehandling. Mens pedicuren tager sig af føddernes ydre sundhed, hudens blødhed og neglenes velpleje, arbejder zoneterapien med de indre reflekszoner og kroppens energibaner. Resultatet er en gennemgribende følelse af lethed, fornyet energi og dyb afslapning i hele kroppen.'
      },
      {
        q: 'Hvad kan jeg selv gøre derhjemme for at bevare det bløde resultat længere?',
        a: 'For at forlænge effekten af din pedicure anbefaler vi, at du smører fødderne ind i en fed, fugtgivende fodcreme hver aften inden sengetid. Undgå at bruge skarpe fodhøvle derhjemme, da for kraftig beskæring kan få huden til at reagere ved at danne endnu mere hård hud som forsvarsmekanisme. Brug i stedet en mild pimpsten eller fodfil under bruseren en gang om ugen.'
      }
    ]
  },
  'cupping-massage': {
    heading: 'Ofte stillede spørgsmål om cupping massage',
    items: [
      {
        q: 'Hvordan virker cupping, og hvad sker der under vakuumkopperne?',
        a: 'Cupping er en ældgammel terapiform, hvor specielle sugekopper skaber et kontrolleret undertryk (vakuum) på huden og det underliggende væv. Modsat traditionel massage, som trykker musklerne indad, løfter cupping bindevævet, muskelfibre og fascier opad og adskiller lagene. Dette skaber øjeblikkelig plads, stimulerer mikrocirkulationen i dybden og aktiverer lymfedrænage af stagnerede affaldsstoffer.'
      },
      {
        q: 'Hvorfor får man mærker på huden efter cupping, og giver det blå mærker?',
        a: 'Hos Djurs Massage tilpasser vi altid cuppingen, så den IKKE giver store blå mærker. De lette rødlige cirkler, der kan opstå, skyldes undertrykket, som trækker stagneret blod og affaldsstoffer op til hudens mikrocirkulation. Cupping har desuden en rigtig god effekt ved cellulitis / appelsinhud og stramt bindevæv.'
      },
      {
        q: 'Gør cuppingmassage ondt at modtage under behandlingen?',
        a: 'Cupping kan i de første minutter mærkes som et stramt, sugende træk i huden, især i områder med stift bindevæv eller gamle myoser. Efter kort tid oplever de fleste dog en dyb, forløsende varme og en følelse af, at spændingerne i muskulaturen smelter væk. Vi tilpasser altid vakuumniveauet og afstemmer med dig, så behandlingen føles behagelig og kontrolleret.'
      },
      {
        q: 'Hvilke symptomer og gener er cupping særligt effektivt imod?',
        a: 'Cupping er ekstremt effektivt til genstridige muskelknuder, stivhed i lænd og ryg, spændingshovedpine, frossen skulder og overbelastede benmuskler. Mange sportsfolk og fysisk aktive bruger cupping til at fremme muskelrestitution og øge smidigheden i bindevævet. Derudover er metoden velegnet til at løsne fastlåst arvæv efter operationer eller langvarige overbelastninger.'
      },
      {
        q: 'Hvad skal jeg være opmærksom på efter en cuppingbehandling?',
        a: 'Efter behandlingen er det meget vigtigt at drikke rigeligt med vand for at hjælpe nyrerne og lymfesystemet med at skylle de frigjorte stoffer ud. Hold de behandlede områder varme, og undgå træk, kolde bade og direkte kulde de første 24 timer, da porerne er åbne. Giv kroppen ro til at restituere, og forvent en behagelig lethed og øget bevægelighed i det behandlede område.'
      }
    ]
  },
  'specialiserede-behandlinger': {
    heading: 'Ofte stillede spørgsmål om specialiserede teknikker',
    items: [
      {
        q: 'Hvilke specialteknikker tilbyder Djurs Massage, og hvordan udvælges de?',
        a: 'Tine råder over en bred vifte af evidensbaserede specialteknikker, herunder terapeutisk ultralyd, medicinsk laser, scraping (Gua Sha), dry needling, øreakupunktur og kinesiologitape. Under den indledende samtale og undersøgelse vurderer Tine din konkrete problemstilling og vælger netop den teknik eller kombination, der mest effektivt løsner dit problem.'
      },
      {
        q: 'Hvordan virker terapeutisk laser- og ultralydsbehandling på skader?',
        a: 'Både laser og ultralyd er smertefri, ikke-invasive teknologier, der arbejder på celleniveau for at accelerere kroppens naturlige helingsproces. Ultralyd skaber dyb mikromassage i vævet og øger blodgennemstrømningen, mens medicinsk laser stimulerer cellernes energiproduktion (ATP) og dæmper inflammation. Teknikkerne er fremragende ved overbelastede sener, fibersprængninger, hælsporer, tennisalbue og ledsmerter.'
      },
      {
        q: 'Hvad er formålet med kinesiologitape, og hvor længe skal det sidde på?',
        a: 'Kinesiologitape er en elastisk bomuldstape, der lægges på huden i specifikke mønstre for at løfte det øverste hudlag en anelse. Dette reducerer trykket på smertereceptorer, forbedrer lymfeflowet og støtter muskler og led uden at hæmme din naturlige bevægelsesfrihed. Tapen er vandafvisende, så du sagtens kan gå i bad med den, og den holder typisk i 3-5 dage.'
      },
      {
        q: 'Hvad kan 5-punkts øreakupunktur (NADA-inspireret) hjælpe imod?',
        a: 'Øreakupunktur er en skånsom metode, hvor små, sterile engangsnåle placeres i præcise punkter i øret for at regulere det autonome nervesystem. Metoden anvendes ofte til at dæmpe stress, uro, angst, søvnproblemer, tankemylder og abstinenser samt til at understøtte smertelindring i kroppen. Behandlingen skaber en dyb indre ro, og mange klienter oplever forbedret mental balance allerede efter første session.'
      },
      {
        q: 'Koster de specialiserede teknikker ekstra ud over klinikkens normale timepris?',
        a: 'Nej, som hovedregel er de specialiserede teknikker (laser, ultralyd, scraping, dry needling, tape mv.) inkluderet i klinikkens faste timepris på 600 kr., når de indgår som del af din fysiurgiske behandling. Der opkræves kun et lille tillæg ved specifikke tilkøb, som for eksempel 150 kr. for supplerende ansigtsmassage. Vi oplyser dig altid gennemskueligt om behandlingsplanen forud for sessionen.'
      }
    ]
  },
  'specialiserede-teknikker': {
    heading: 'Ofte stillede spørgsmål om specialiserede teknikker',
    items: [
      {
        q: 'Hvilke specialteknikker tilbyder Djurs Massage, og hvordan udvælges de?',
        a: 'Tine råder over en bred vifte af evidensbaserede specialteknikker, herunder terapeutisk ultralyd, medicinsk laser, scraping (Gua Sha), dry needling, øreakupunktur og kinesiologitape. Under den indledende samtale og undersøgelse vurderer Tine din konkrete problemstilling og vælger netop den teknik eller kombination, der mest effektivt løsner dit problem.'
      },
      {
        q: 'Hvordan virker terapeutisk laser- og ultralydsbehandling på skader?',
        a: 'Både laser og ultralyd er smertefri, ikke-invasive teknologier, der arbejder på celleniveau for at accelerere kroppens naturlige helingsproces. Ultralyd skaber dyb mikromassage i vævet og øger blodgennemstrømningen, mens medicinsk laser stimulerer cellernes energiproduktion (ATP) og dæmper inflammation. Teknikkerne er fremragende ved overbelastede sener, fibersprængninger, hælsporer, tennisalbue og ledsmerter.'
      },
      {
        q: 'Hvad er formålet med kinesiologitape, og hvor længe skal det sidde på?',
        a: 'Kinesiologitape er en elastisk bomuldstape, der lægges på huden i specifikke mønstre for at løfte det øverste hudlag en anelse. Dette reducerer trykket på smertereceptorer, forbedrer lymfeflowet og støtter muskler og led uden at hæmme din naturlige bevægelsesfrihed. Tapen er vandafvisende, så du sagtens kan gå i bad med den, og den holder typisk i 3-5 dage.'
      },
      {
        q: 'Hvad kan 5-punkts øreakupunktur (NADA-inspireret) hjælpe imod?',
        a: 'Øreakupunktur er en skånsom metode, hvor små, sterile engangsnåle placeres i præcise punkter i øret for at regulere det autonome nervesystem. Metoden anvendes ofte til at dæmpe stress, uro, angst, søvnproblemer, tankemylder og abstinenser samt til at understøtte smertelindring i kroppen. Behandlingen skaber en dyb indre ro, og mange klienter oplever forbedret mental balance allerede efter første session.'
      },
      {
        q: 'Koster de specialiserede teknikker ekstra ud over klinikkens normale timepris?',
        a: 'Nej, som hovedregel er de specialiserede teknikker (laser, ultralyd, scraping, dry needling, tape mv.) inkluderet i klinikkens faste timepris på 600 kr., når de indgår som del af din fysiurgiske behandling. Der opkræves kun et lille tillæg ved specifikke tilkøb, som for eksempel 150 kr. for supplerende ansigtsmassage. Vi oplyser dig altid gennemskueligt om behandlingsplanen forud for sessionen.'
      }
    ]
  },
  'behandlingstyper': {
    heading: 'Ofte stillede spørgsmål om behandlingstyper & metoder',
    items: [
      {
        q: 'Hvad koster behandlingerne hos Djurs Massage?',
        a: 'Vores priser starter fra 300 kr. for en halv time (30 min.), baseret på en enkel og gennemskuelig timepris på 600 kr. for fysiurgisk massage, zoneterapi og relax massage. Vi tilbyder sessioner på 30, 45, 60 og 90 minutter, så du frit kan vælge den varighed, der passer til dig.'
      },
      {
        q: 'Hvordan ved jeg, hvilken behandlingstype der er den rigtige for mig?',
        a: 'Hvis du er i tvivl om, hvilken behandling der bedst afhjælper dine gener, behøver du ikke bekymre dig forud for din booking. Når du møder op i klinikken på Poppelvej 52 i Ryomgård, tager vi altid en indledende snak om dine symptomer, smerter og ønsker. Vores erfarne behandlere rådgiver dig ærligt og sammensætter den mest hensigtsmæssige kombination af teknikker til din krop.'
      },
      {
        q: 'Kan man kombinere flere forskellige behandlingsteknikker under samme tid?',
        a: 'Ja, det er en af vores helt store styrker, at vi ofte integrerer flere specialiserede teknikker i én og samme behandling. En fysiurgisk massage kan eksempelvis kombineres med cupping, terapeutisk ultralyd, laser eller kinesiologitape uden ekstra beregning i timeprisen. Ligeledes vælger mange klienter at booke en kombination af zoneterapi og en skønhedsbehandling som voks eller pedicure.'
      },
      {
        q: 'Kan jeg få tilskud fra Sygeforsikringen ”danmark” eller sundhedsforsikring?',
        a: 'Ja, du har rigtig gode muligheder for tilskud og forsikringsdækning hos os. Vores zoneterapeut Sophie Hebsgaard Ede er RAB-godkendt, hvilket berettiger til tilskud fra Sygeforsikringen ”danmark” samt de fleste private sundhedsordninger. Vores fysiurgiske massør Tine er RAB-godkendt (eneste officielle kvalitetsstempel for massører) og desuden godkendt ved Falck Healthcare og AP Pension, så du kan bruge din sundhedsordning direkte i klinikken.'
      },
      {
        q: 'Hvordan bestiller jeg tid, og hvad hvis der ikke er en ledig tid?',
        a: 'Den nemmeste måde at booke på er via vores døgnåbne online booking. Hvis du ikke finder en tid, der passer dig, anbefaler vi at benytte vores venteliste i bookingsystemet. Da vi ofte er optaget af behandlinger og ønsker ro om klienterne, foretrækkes skriftlige henvendelser (via kontaktformularen eller SMS på 28 58 39 07), så svarer vi dig hurtigst muligt.'
      }
    ]
  }
};

export default function TreatmentFAQ({ treatmentSlug, className = '' }) {
  // Normalize slug to match our dictionary
  const normalizedSlug = treatmentSlug
    ? treatmentSlug.toLowerCase().trim()
    : 'fysiurgisk-massage';

  const faqData = TREATMENT_FAQS[normalizedSlug] || TREATMENT_FAQS['fysiurgisk-massage'];
  const [openIndex, setOpenIndex] = useState(0); // Open the first question by default for great UX

  const toggleItem = (idx) => {
    setOpenIndex(openIndex === idx ? -1 : idx);
  };

  return (
    <section
      aria-labelledby="faq-heading"
      className={`bg-white border-t border-[#E8E1D5] pt-12 pb-8 ${className}`}
    >
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-[#C9A770] mb-2">
            <i className="fa-solid fa-circle-question text-sm" aria-hidden="true" />
            <span>Spørgsmål & Svar</span>
          </div>
          <h2
            id="faq-heading"
            className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1E3A5F] font-serif"
          >
            {faqData.heading}
          </h2>
          <p className="text-slate-600 text-xs sm:text-sm mt-2 leading-relaxed">
            Få svar på de mest almindelige spørgsmål om behandlingen, forberedelse, forsikring og hvad du kan forvente i klinikken i Ryomgård.
          </p>
        </div>

        <div className="divide-y divide-[#E8E1D5] border-y border-[#E8E1D5]">
          {faqData.items.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div key={idx} className="py-4 sm:py-5">
                <button
                  type="button"
                  onClick={() => toggleItem(idx)}
                  className="w-full flex items-start justify-between text-left gap-4 group focus:outline-hidden"
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${idx}`}
                  id={`faq-question-${idx}`}
                >
                  <span
                    className={`text-sm sm:text-base font-bold transition-colors ${
                      isOpen ? 'text-[#1E3A5F]' : 'text-slate-800 group-hover:text-[#1E3A5F]'
                    }`}
                  >
                    <span className="text-[#C9A770] mr-2.5 font-semibold">0{idx + 1}.</span>
                    {item.q}
                  </span>
                  <span
                    className={`shrink-0 ml-2 w-7 h-7 rounded-full flex items-center justify-center border transition-all ${
                      isOpen
                        ? 'bg-[#1E3A5F] text-white border-[#1E3A5F]'
                        : 'bg-[#F8F5EE] text-slate-600 border-[#E8E1D5] group-hover:border-[#C9A770]'
                    }`}
                    aria-hidden="true"
                  >
                    <i
                      className={`fa-solid fa-chevron-down text-xs transition-transform duration-200 ${
                        isOpen ? 'rotate-180' : ''
                      }`}
                    />
                  </span>
                </button>

                {isOpen && (
                  <div
                    id={`faq-answer-${idx}`}
                    role="region"
                    aria-labelledby={`faq-question-${idx}`}
                    className="mt-3 pr-4 sm:pr-8 pl-6 sm:pl-8 text-xs sm:text-sm text-slate-700 leading-relaxed border-l-2 border-[#C9A770]"
                  >
                    <p>{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Reassurance footer bar in FAQ section */}
        <div className="mt-8 p-4 sm:p-5 bg-[#FAF7F2] border border-[#E8E1D5] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs sm:text-sm">
          <div className="flex items-center gap-3 text-slate-700 text-center sm:text-left">
            <i className="fa-solid fa-comments text-[#C9A770] text-lg shrink-0" aria-hidden="true" />
            <p>
              Har du et andet spørgsmål til behandlingen? Vi står altid klar til at vejlede dig på telefon{' '}
              <a href="tel:28583907" className="font-bold text-[#1E3A5F] hover:underline">
                28 58 39 07
              </a>.
            </p>
          </div>
          <a
            href="https://djursmassage.app4.geckobooking.dk/site/booking.php?show=new_booking&icCode=69a506a6f06a0ca7022b880e8f6bcb65b11332&bId=11332&aDIfH=1&dTpl=1&sSToken=267bea05a53684a4a7d7ad2e6bae564a"
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 px-4 py-2 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow inline-flex items-center gap-1.5"
          >
            <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
            <span>Book tid online</span>
          </a>
        </div>
      </div>
    </section>
  );
}
